import { FC } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import toggleSideNav from 'modules/_shared/redux/sideNavActions';

type Props = {
  order: string;
  isActive: boolean;
};

const MainBeneficiatedMenu: FC<Props> = ({ order, isActive }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-star" />
            </span>
            <span className="nk-menu-text">{t('Plans')}</span>
          </a>
        </li>
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          <li className="nk-menu-item">
            <Link
              to="/lista-beneficiadas"
              className="nk-menu-link"
              onClick={() => dispatch(toggleSideNav())}
            >
              <span className="nk-menu-text">{t('PlansList')}</span>
            </Link>
          </li>
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default MainBeneficiatedMenu;
